<div class="layout-ParentDiv innerDiv">
	<div class="layout-dashboard">

			<p-toast key="toastmsg"></p-toast>

			<div class="mainDivHeader">
				<div class="leftdiv">
					<h4>Player Video Request List<span class="badge">{{ totalRecords }}</span></h4>
				</div>
				<div class="rightDiv">
					<button (click)="clear()" class="clearFilterBtn">
						<img src="../../../assets/images/backend-image/common-images/delete.svg" alt="">
						<span>Clear All</span>
					</button>
				</div>
			</div>

			<!-- <div class="card">
				<div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-2"> 
						<label for="searchfield">Select Field</label>
						<p-dropdown inputId="searchfield" [options]="searchBy" [(ngModel)]="searchby" placeholder="Select Field" optionLabel="label"></p-dropdown>
					</div>
					<div class="p-field p-col-3"> 
						<label for="startdt">Start Date</label>
						<p-calendar  monthNavigator="true" yearNavigator="true" yearRange="2022:2050"  [(ngModel)]="startDate" class="p-calendar" inputId="calendar" dateFormat="dd/mm/yy" [showIcon]="true" ></p-calendar>
					</div>
					<div class="p-field p-col-3"> 
						<label for="enddt">End Date</label>
						<p-calendar  monthNavigator="true" yearNavigator="true" yearRange="2022:2050"  [(ngModel)]="endDate" class="p-calendar" inputId="calendar"  dateFormat="dd/mm/yy" [showIcon]="true" ></p-calendar>
					</div>
					<div class="p-field p-col-3"> 						
						<button pButton pRipple label="Search" class="p-button p-mr-1 p-mb-2" (click)="loadUsers($event)"></button>
					</div>
				</div>
			</div> -->

			
			<div class="mainDivBody">
				<div class="maintableDiv">
					<div class="tableParanet">
						<p-table class="p2-table-columns show-columns" #dt [value]="userlist" [paginator]="true" [rows]="10"
							[lazy]="true" (onLazyLoad)="loadUsers($event)" [totalRecords]="totalRecords" [loading]="loading"
							[rowsPerPageOptions]="paginationOption" styleClass="p-datatable-gridlines p-datatable-striped">

							<ng-template pTemplate="header" let-columns>
								<tr>
									<th pSortableColumn="firstName" class="NameTD" style="min-width: 150px;">
										<div class="p-d-flex p-jc-between p-ai-center">
											First Name
											<p-sortIcon field="firstName"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="lastName" class="NameTD" style="min-width: 150px;">
										<div class="p-d-flex p-jc-between p-ai-center">
											Last Name
											<p-sortIcon field="lastName"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="gender" class="gender-td">
										<div class="p-d-flex p-jc-between p-ai-center">
											Gender
											<p-sortIcon field="gender"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="email" class="emailTD" [style]="{'width':'210px'}">
										<div class="p-d-flex p-jc-between p-ai-center">
											Email Id
											<p-sortIcon field="email"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="dob" class="col-width DOBTD">
										<div class="p-d-flex p-jc-between p-ai-center">
											DOB
											<p-sortIcon field="dob"></p-sortIcon>
										</div>
									</th>
									<!-- <th pSortableColumn="weddingDate" class="col-width">
										<div class="p-d-flex p-jc-between p-ai-center">
											Wedding Date
											<p-sortIcon field="weddingDate"></p-sortIcon>
										</div>
									</th> -->
									<th pSortableColumn="updated_at" class="col-width Modificationdatetd">
										<div class="p-d-flex p-jc-between p-ai-center">
											Request Date
											<p-sortIcon field="updated_at"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="isplayerVideoApproved" class="isplayerVideoApproved-td">
										<div class="p-d-flex p-jc-between p-ai-center">
											User Video
											<p-sortIcon field="isplayerVideoApproved"></p-sortIcon>
										</div>
									</th>
									<th pSortableColumn="isplayerVideoApproved" class="isplayerVideoApproved-td">
										<div class="p-d-flex p-jc-between p-ai-center">
											Action 
										</div>
									</th>
								
									<!-- <th [style]="{'width':'auto'}">
										<div class="p-d-flex p-jc-between p-ai-center">
											Action
										</div>
									</th> -->
								</tr>
								<tr>
									<th [ngSwitch]="firstName" class="NameTD">
										<input pInputText type="text"
											(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'firstName', 'contains')"
											[value]="dt.filters['firstName'] ? dt.filters['firstName'].value : ''" />
									</th>
									<th [ngSwitch]="lastName" class="NameTD">
										<input pInputText type="text"
											(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'lastName', 'contains')"
											[value]="dt.filters['lastName'] ? dt.filters['lastName'].value : ''" />
									</th>
									<th [ngSwitch]="gender" class="gender-td">
										<p-dropdown #pDropDownId [options]="genders"
											(onChange)="setDownloadFlag(); dt.filter($event.value, 'gender', 'equals')"
											styleClass="p-column-filter" placeholder="Select Gender" [showClear]="true">
											<ng-template let-option pTemplate="item">
												<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
											</ng-template>
										</p-dropdown>
									</th>
									<th [ngSwitch]="email" class="emailTD">
										<input pInputText type="text"
											(keyup.enter)="setDownloadFlag(); dt.filter($event.target.value, 'email', 'contains')"
											[value]="dt.filters['email'] ? dt.filters['email'].value : ''" />
									</th>
									<th [ngSwitch]="dob" class="DOBTD">
										<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
											dateFormat="dd/mm/yy" (onSelect)="setDownloadFlag(); dt.filter($event,'dob', 'dateIs')"
											[showIcon]="true" [(ngModel)]="dcalvalue"></p-calendar>
									</th>
									<!-- <th [ngSwitch]="weddingDate" class="">
										<p-calendar #pCalendarId class="p-column-filter" inputId="calendar" dateFormat="dd/mm/yy"
											(onSelect)="setDownloadFlag(); dt.filter($event,'weddingDate', 'dateIs')"
											[showIcon]="true" [(ngModel)]="wdcalvalue"></p-calendar>
									</th> -->
									<th [ngSwitch]="updated_at" class="Modificationdatetd">
										<p-calendar appendTo="body" #pCalendarId class="p-column-filter" inputId="calendar"
											dateFormat="dd/mm/yy"
											(onSelect)="setDownloadFlag(); dt.filter($event,'updated_at', 'dateIs')"
											[showIcon]="true" [(ngModel)]="ucalvalue"></p-calendar>
									</th>
									<th [ngSwitch]="isplayerVideoApproved" class="status-td isplayerVideoApproved-td">
										<!-- <p-dropdown #pDropDownId [options]="statuses"
											(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
											styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
											<ng-template let-option pTemplate="item">
												<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
											</ng-template>
										</p-dropdown> -->
									</th>
									<th [ngSwitch]="isplayerVideoApproved" class="status-td isplayerVideoApproved-td">
										<!-- <p-dropdown #pDropDownId [options]="statuses"
											(onChange)="setDownloadFlag(); dt.filter($event.value, 'status', 'equals')"
											styleClass="p-column-filter" placeholder="Select Status" [showClear]="true">
											<ng-template let-option pTemplate="item">
												<span [class]="'customer-badge status-' + option.value">{{option.label}}</span>
											</ng-template>
										</p-dropdown> -->
									</th>
									<!-- <th>
									
									</th> -->
								</tr>
							</ng-template>
							<ng-template pTemplate="body" let-user>
								<tr class="p-selectable-row">
									<td class="NameTD">
										{{user.firstName}}
									</td>
									<td class="NameTD">
										{{user.lastName}}
									</td>
									<td class="gender-td">
										{{user.gender}}
									</td>
									<td class="emailTD">
										{{user.email}}
									</td>
									<td class="DOBTD">
										{{user.dob}}
									</td>
									<!-- <td>
										{{user.weddingDate | date:'d/M/yyyy'}}
									</td> -->
									<td class="Modificationdatetd">
										{{user.updated_at | date:'dd/MM/yyyy'}}
									</td>
									
									<td class="text-center status-td isplayerVideoApproved-td">
										<div class="pan-image" *ngIf="user.playervideoClip!=''">
											<p-button label="Watch Video" icon="pi pi-play" [rounded]="true" severity="secondary"
												(click)="playVideo(user.playervideoClip)"></p-button>
											<!-- 
											<button pButton pRipple icon="pi pi-video" class="p-button-rounded p-button-success"
												pTooltip="Edit Player "
												tooltipPosition="bottom"></button> -->
											<!-- <video class="" width="50%" controls="" loop="">
												<source type="video/mp4" src="{{user.playervideoClip}}" />
											</video> -->
										</div>
									</td>
									<td class="text-center status-td">
										<div class="status-buttons">
											<button class="btn btn-success" (click)="changeStatusToApprove(user)"> Approve </button>
											<button class="btn btn-danger" (click)="showPaymentrejectmodal(user)"> Reject </button>
										</div>
										<!-- <p-inputSwitch [(ngModel)]="user.isplayerVideoApproved"
											(onChange)="changeStatus(user)"></p-inputSwitch> -->
									</td>
								</tr>
							</ng-template>
							<ng-template pTemplate="emptymessage">
								<tr>
									<td colspan="7">No Videos found.</td>
								</tr>
							</ng-template>
							<!-- <ng-template pTemplate="summary">
								<div class="p-d-flex p-ai-center p-jc-between">
									In total there are {{totalRecords }} Videos.
								</div>
							</ng-template> -->
						</p-table>
					</div>
				</div>		
			</div>	

		<p-confirmDialog [style]="{width: '400px'}" id="confirmDialog"></p-confirmDialog>

		<p-dialog id="showVideo" [(visible)]="showVideo"
			[breakpoints]="{ '960px': '75vw', '768px': 'calc(100% - 20px)' }" [style]="{ width: '500px' }"
			[modal]="true" [draggable]="false" [resizable]="false" (onHide)="onshowVideoClose()" header="Player Video">
			<!---test-->
			<div class="modal-dialog modal-dialog-centered modal-dialog-scrollable"
				style="margin: 0px!important;    width: 100%; max-width: 100%;">
				<div class="modal-content">
					<div class="modal-header p-p-0">

						<div class="headings col-md-12  p-p-0">
							<!-- <video class="" width="50%" controls="" loop="">
							<source type="video/mp4" src="{{selectedVideo}}" />
						</video> -->
							<video width="100%" [src]="selectedVideo" controls="" loop="">
								Your browser does not support HTML5 video.
							</video>
						</div>
					</div>
				</div>
			</div>
		</p-dialog>
		<p-dialog header="Mention Reject Reason" (onHide)="onPaymentmodalModalClose()" [(visible)]="paymentReject"
			[modal]="true" [style]="{ width: '400px' }" [draggable]="false" [resizable]="false" id="rejectModal"
			class="modal-payment-select">
			<form [formGroup]="rejectUpdateForm" (ngSubmit)="changeStatusToReject()">
				<div class="p-grid">
					<div class="col-12">
						<div class="form-div">
							<label for="comment"> Add Reason <span class="mandatory-fields ">*</span>
							</label>
							<textarea pInputTextarea rows="5" formControlName="comment"
								[ngClass]="{ 'is-invalid': submitted && f.comment.errors }"></textarea>
							<div *ngIf="((submitted && f.comment.errors) || (f.comment.errors && (f.comment.dirty || f.comment.touched)))"
								class="invalid-feedback">
								<div *ngIf="f.comment.errors.required">
									Reason is required</div>
							</div>
						</div>
					</div>
					<div class="col-12 footer-forms">
						<button class="btn cancel-btn" (click)="onPaymentmodalModalClose()"> Cancel </button>
						<button class="btn rejectBtn" type="submit"> Reject </button>
					</div>
				</div>
			</form>
		</p-dialog>
	</div>
</div>